import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Column } from '@simplywallst/ui-core';
import { Row } from '@simplywallst/ui-core';
import { sectionHeading } from '../../styled';
import { EmblaDots } from '@/components/Carousel/styled';

interface FeatureProps {
  bgColor: string;
}

export const ValuesContainerRow = styled(Row)`
  width: 100%;
  padding-bottom: ${({ theme }) => theme.x6spacePx}px;
`;

export const ValuesHeader = styled.div`
  margin: ${({ theme }) => theme.x4spacePx}px
    ${({ theme }) => theme.x2spacePx}px 0;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x7spacePx}px;
  `}
  text-align: center;
  h2 {
    ${sectionHeading}
  }
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGray};
  }
`;

export const Value = styled(Column)<FeatureProps>`
  padding: ${({ theme }) => theme.x4spacePx}px;
  border-radius: 40px;
  border: 20px solid #fff;
  background: ${({ bgColor }) => `${bgColor}`};
  color: ${({ theme }) => theme.color.noir};
  ${media.xlUp`
    border-radius: 40px;
    border: 16px solid #fff;
    padding: ${({ theme }) => theme.x6spacePx}px;
  `}
`;

export const ValuesContentRow = styled(Row)`
  ${EmblaDots} {
    bottom: -25px;
  }
`;

export const StyledReactMarkdown = styled('div')`
  h3 {
    ${({ theme }) => theme.typography.uberStrong};
    margin-top: -${({ theme }) => theme.x1spacePx}px;
    line-height: 70px;
    ${media.mdDown`
      font-size: 56px;
    `}
  }
  h4 {
    margin-top: -${({ theme }) => theme.x2spacePx}px;
    ${({ theme }) => theme.typography.megaStrong};
    min-height: 75px;
  }
  p {
    ${({ theme }) => theme.typography.large};
    line-height: 30px;
  }
`;
